var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSwitchSelectedR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 52,
  height: 48,
  viewBox: "0 0 52 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 8,
  width: 52,
  height: 32,
  rx: 16,
  fill: "#00BFFF"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 12,
  width: 24,
  height: 24,
  rx: 12,
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSwitchSelectedR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/switch-selected-r.6d7264275f133b2ac522046b3c4b8e10.svg";